module.exports = __webpack_public_path__ + "img/416.c0529700.jpg";